import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './DonaQR.css';
import donaqrimage from '../../assets/pageimages/DonaQR.webp';

function DonaQRHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>DonaQR - Generosity & Kindness </h2>
      </div>
      <div className="main-content">
      <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/donaqr-myqrlist" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="donaqr-bottomlink-style" />My Codes</Link></div>
            <div className="bottom-buttons-box"><Link to="/donaqr-scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="donaqr-bottomlink-style" />Donate</Link></div>
            <div className="bottom-buttons-box"><Link to="/donaqr-mydonationslist" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="donaqr-bottomlink-style" />My Donations</Link></div>
            <div className="bottom-buttons-box"><Link to="/donaqr-myincentivelist" className="top-button-link"><FontAwesomeIcon icon={faStar} className="donaqr-bottomlink-style" />My Incentives</Link></div>
            <div className="bottom-buttons-box"><Link to="/donaqr-testgenerate" className="top-button-link"><FontAwesomeIcon icon={faStar} className="donaqr-bottomlink-style" />Test Generate QR</Link></div>
            <div className="bottom-buttons-box"><Link to="/donaqr-testscan" className="top-button-link"><FontAwesomeIcon icon={faStar} className="donaqr-bottomlink-style" />Test Scan QR</Link></div>     
            <div className="bottom-buttons-box"><Link to="/donaqr-testread" className="top-button-link"><FontAwesomeIcon icon={faStar} className="donaqr-bottomlink-style" />Test Read QR</Link></div>     
          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="donaqr-id" src={donaqrimage} alt="DonaQR Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default DonaQRHome;
